import { StatCard } from "../../components/shared/StatCard";
import { PageHeader } from "../../components/shared/PageHeader";
import { cn } from "@nthamizh/ui";
import { useSystemHealth } from "@platform/hooks";

export function PlatformSystemHealthPage() {
  const { data: health, isLoading } = useSystemHealth();

  const uptimeDays = health ? Math.floor(health.uptime / 86400) : 0;
  const uptimeHours = health ? Math.floor((health.uptime % 86400) / 3600) : 0;

  return (
    <div className="space-y-6">
      <PageHeader title="System health" subtitle="Infrastructure and service status" />
      {isLoading ? <div className="p-8 text-center text-sm text-ds-text-muted">Loading...</div> : (
        <>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            <StatCard label="API status" value={health?.status === "ok" ? "Healthy" : "Degraded"} deltaType={health?.status === "ok" ? "positive" : "negative"} />
            <StatCard label="Uptime" value={`${uptimeDays}d ${uptimeHours}h`} />
            <StatCard label="Memory" value={`${health?.memoryMb ?? 0} MB`} />
            <StatCard label="Node version" value={health?.nodeVersion ?? "—"} />
          </div>

          {/* VPS disk usage */}
          {health?.disk && (
            <div className="bg-white border border-ds-border rounded-card shadow-card p-5">
              <h2 className="text-sm font-semibold text-ds-text mb-3">VPS disk</h2>
              <div className="flex items-center justify-between mb-2">
                <p className="text-xs text-ds-text-secondary">{health.disk.usedGb} GB used of {health.disk.totalGb} GB</p>
                <p className="text-xs text-ds-text-muted">{health.disk.freeGb} GB free · {health.disk.usagePercent}%</p>
              </div>
              <div className="h-2.5 bg-ds-bg border border-ds-border rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all ${health.disk.usagePercent >= 90 ? "bg-red-500" : health.disk.usagePercent >= 70 ? "bg-amber-400" : "bg-indigo-500"}`}
                  style={{ width: `${health.disk.usagePercent}%` }}
                />
              </div>
              <p className="text-xs text-ds-text-muted mt-1.5">Root filesystem (/) — shared across all containers on this VPS.</p>
            </div>
          )}
          <div className="bg-white border border-ds-border rounded-card shadow-card p-5">
            <h2 className="text-sm font-semibold text-ds-text mb-4">Live API metrics</h2>
            <div className="space-y-3">
              {[
                { name: "API server", detail: "Express 5 · healthy", status: "ok" as const },
                { name: "PostgreSQL", detail: "PG 17 · healthy", status: "ok" as const },
                { name: "GitHub sync", detail: "Managed by Migrate module", status: "ok" as const },
              ].map((s) => (
                <div key={s.name} className="flex items-center gap-3">
                  <div className={cn("w-2 h-2 rounded-full flex-shrink-0", s.status === "ok" ? "bg-emerald-500" : "bg-amber-400")} />
                  <p className="text-sm text-ds-text flex-1">{s.name}</p>
                  <p className="text-xs text-ds-text-muted">{s.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
